import { TwitterCard } from '../../Widget/Social/TwitterCard';

import { TwitterPost } from '../../Widget/Social/types';

export const Tweets = ({ tweets }: { tweets: TwitterPost[] }) => (
  <div className={'grid gap-4 grid-cols-2 p-4'}>
    {tweets.map((tweet, index) => (
      <TwitterCard post={tweet} key={tweet.id} />
    ))}
  </div>
);
